import {
  DataGrid,
  DataGridActions,
  DataGridColumns,
  DataGridSections,
  DataGridSelectedActions,
} from '@components/DataGrid/DataGrid'
import { DataGridPerson } from '@components/DataGrid/DataGridPerson'
import { useLocation, useNavigate } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'
import { ActionIcon, Box, Button, Menu, Stack, Text } from '@mantine/core'
import classes from '@styles/record.module.css'
import { IconChevronDown, IconDots } from '@tabler/icons-react'
import { randomArrayItem } from '@utils/randomArrayItem'
import { DataGridList } from '@components/DataGrid/DataGridList'
import { StageListItem } from '@components/StageList/StageList'
import cn from 'classnames'
import ExampleUser from '@assets/exampleUser.png'

export interface NotesProps {
  fullWidth?: boolean
  state?: { history: any }
}

export const Notes = (props: NotesProps) => {
  const { fullWidth, state } = props

  const navigate = useNavigate()
  const location = useLocation()

  const handleNavigate = () =>
    navigate(
      `../${RoutePaths.RECORD}/123/${RoutePaths.RECORD_HOME}`,
      location?.state?.history
        ? { state: location?.state }
        : state
        ? { state }
        : {},
    )

  const data = Array(30)
    .fill(0)
    .map((_, i) => {
      return {
        id: `invite-${i}`,
        created: (
          <Stack gap={0}>
            <Text size="xs">5:59pm</Text>
            <Text size="xs" c="dimmed">
              Mar 11
            </Text>
          </Stack>
        ),
        staff: (
          <DataGridPerson
            name="Alfredo Carrillo"
            status="online"
            onClick={handleNavigate}
          />
        ),
        record: (
          <DataGridPerson
            name="Joey Cadle"
            image={ExampleUser}
            status="online"
            onClick={handleNavigate}
          />
        ),
        notes: randomArrayItem([
          'Let him know how...',
          'Don’t forget to bring presents.',
          'Remind him to take care of him...',
          'Don’t forget that thing that was ...',
        ]),
        context: randomArrayItem([
          'Email',
          'Meeting',
          'Incident',
          'Action item',
        ]),
        tags: (
          <DataGridList title="Tags" data={['Some', 'Another', 'Another']} />
        ),
        incidentDate: (
          <Stack gap={0}>
            <Text size="xs">5:59pm</Text>
            <Text size="xs" c="dimmed">
              Mar 11
            </Text>
          </Stack>
        ),
        location: 'Playground',
        source: 'Safety agent',
        actionTaken: 'Email sent',
      }
    })

  const fullWidthCols = fullWidth
    ? [
        {
          label: 'Created',
          prop: 'created',
          defaultSort: true,
          pinned: true,
        },
        {
          label: 'Record',
          prop: 'record',
        },
      ]
    : [
        {
          label: 'Created',
          prop: 'created',
          defaultSort: true,
          pinned: true,
        },
      ]

  const columns: DataGridColumns[] = [
    ...fullWidthCols,
    {
      label: 'Staff',
      prop: 'staff',
      pinned: true,
    },
    {
      label: 'Notes',
      prop: 'notes',
    },
    {
      label: 'Context',
      prop: 'context',
    },
    {
      label: 'Tags',
      prop: 'tags',
    },
    {
      label: 'Incident Date',
      prop: 'incidentDate',
    },
    {
      label: 'Location',
      prop: 'location',
    },
    {
      label: 'Source',
      prop: 'source',
    },
    {
      label: 'Action Taken',
      prop: 'actionTaken',
    },
  ]

  const sections: DataGridSections[] = [
    {
      label: 'All Notes',
      href: '#',
      default: true,
    },
    {
      label: 'My Notes',
      href: '#',
    },
  ]

  const actions: DataGridActions[] = [
    {
      label: 'Edit',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Add tags',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Remove tags',
      color: 'red',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Delete',
      color: 'red',
      onClick: (item: any) => console.log('Action'),
    },
  ]

  const selectedActions: DataGridSelectedActions[] = [
    {
      label: 'Tags',
      onClick: (items: any) => console.log('Selected Actions: Tags'),
      component: (
        <div>
          <Menu position="bottom-start">
            <Menu.Target>
              <Button
                variant="default"
                rightSection={<IconChevronDown size={18} />}
              >
                Tags
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item>Add tags</Menu.Item>
              <Menu.Item color="red">Remove tags</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>
      ),
    },
    {
      label: 'Options',
      onClick: (items: any) => {},
      component: (
        <div>
          <Menu>
            <Menu.Target>
              <ActionIcon variant="default" radius="xl" aria-label="Options">
                <IconDots
                  style={{ width: '70%', height: '70%' }}
                  stroke={1.5}
                />
              </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item color="red">Delete</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>
      ),
    },
  ]

  const stages: StageListItem[] = [
    {
      name: 'Total',
      count: 4,
    },
    {
      name: 'Notes',
      count: 3,
    },
    {
      name: 'Incidents',
      count: 1,
    },
  ]

  return (
    <Box className={cn({ [classes.Record__content]: !fullWidth })}>
      <DataGrid
        data={data}
        columns={columns}
        sections={sections}
        actions={actions}
        stages={stages}
        results={data.length}
        buttons={
          <Menu>
            <Menu.Target>
              <Button rightSection={<IconChevronDown size={18} />}>Add</Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item>Note</Menu.Item>
              <Menu.Item>Incident</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        }
        selectedActions={selectedActions}
        page={1}
      />
    </Box>
  )
}
